
angular.module('bmsApp.crm.document').controller('DocumentDropzoneCtrl', [
	'$rootScope',
	'$scope',
	'$ngBootbox',
	'notify',
	'DocumentSvc', function (
		$rootScope,
		$scope,
		$ngBootbox,
		notify,
		DocumentSvc) {

		$scope.dropzoneErrors = [];
		$scope.dropzone = {
			config: {
				url: 'api/document/upload',
				parallelUploads: 3,
				maxFileSize: 5,
				acceptedFiles: '.csv, .xls, .xlsx, .jpg, .jpeg, .png, .doc, .docx, .pdf',
				eventHandlers: {
					drop: function (event) {
						$scope.dropzoneErrors = [];
					},
					queuecomplete: function () {
						this.removeAllFiles(); // empty the dropzone
						$rootScope.$broadcast('DocumentDropzone-queuecomplete');
					},
					error: function (file, error) {
						$scope.dropzoneErrors.push(error.errors[0]);
					}
				}
			}
		};

	}]);
